let hdapi = {
	// 是否是electron环境
	is_electron: !!window.electron_api,
	platform: getOS(),
	platform_version: getOSversion(),
	// 当前打开文件路径
	current_file_path: "",
	ready: Promise.resolve(),
	getArgs() {
		if (hdapi.is_electron) {
			return electron_api.call("getArgs", Array.from(arguments));
		}
		return Promise.resolve("");
	},
	getPath(name) {
		if (hdapi.is_electron) {
			return electron_api.call("getPath", Array.from(arguments));
		}
		return Promise.resolve("");
	},
	open(url) {
		if (hdapi.is_electron) {
			return electron_api.call("createWindow", Array.from(arguments));
		}
		window.open(url);
	},
	/**
	 * 选择保存文件路径，返回文件路径
	 * @param {string} [title] 默认文件名称
	 * @param {string} [ext] 限定文件后缀
	 * @returns {Promise<string>}
	 */
	pickSaveFile(title, ext) {
		if (hdapi.is_electron) {
			return electron_api.call("pickSaveFile", Array.from(arguments));
		}
	},
	/**
	 * 选取文件，返回文件路径
	 * @param {string} [ext] 文件后缀
	 * @param {boolean} [multi] 允许多选
	 * @returns {Promise<string>}
	 */
	pickFile(ext, multi) {
		if (hdapi.is_electron) {
			return electron_api.call("pickFile", Array.from(arguments));
		}
	},
	/**
	 * 选取文件夹
	 * @param {string} [defaultPath] 默认路径
	 * @returns {Promise<string>}
	 */
	pickDir(defaultPath) {
		if (hdapi.is_electron) {
			return electron_api.call("pickDir", Array.from(arguments));
		}
	},
	/**
	 * 文件修改时间，文件不存在返回0
	 * @param {string} path 文件路径
	 * @returns {number}
	 */
	getFileModifyAt(path) {
		if (hdapi.is_electron) {
			return electron_api.call("getFileModifyAt", Array.from(arguments));
		}
	},
	/**
	 *
	 * @param {string} path 文件路径
	 * @param {string} [encode] 编码
	 * @returns
	 */
	readFile(path, encode) {
		if (hdapi.is_electron) {
			return electron_api.call("readFile", Array.from(arguments));
		}
	},
	/**
	 * 读取文件
	 * @param {string} path 保存路径
	 * @param {any} fileData 可以JSON.stringify的数据
	 * @returns {Promise<void>}
	 */
	writeFile(path, data) {
		if (hdapi.is_electron) {
			return electron_api.call("writeFile", Array.from(arguments));
		}
	},
	readdir(path) {
		if (hdapi.is_electron) {
			return electron_api.call("readdir", Array.from(arguments));
		}
	},
	unlink(path) {
		if (hdapi.is_electron) {
			return electron_api.call("unlink", Array.from(arguments));
		}
	},
	showItemInfolder() {
		var pms = Promise.resolve();
		for (let i = 0; i < arguments.length; i++) {
			let path = arguments[i];
			pms = pms.then(
				(x) =>
					x ||
					hdapi.stat(path).then(
						(x) => {
							if (hdapi.is_electron) {
								electron_api.call("showItemInfolder", [path]);
								return true;
							}
						},
						() => 0
					)
			);
		}
		return pms;
	},
	stat(path) {
		if (hdapi.is_electron) {
			return electron_api.call("stat", Array.from(arguments));
		}
	},
	exists(path) {
		return hdapi.stat(path).then(
			(x) => true,
			(x) => false
		);
	},
	mkdirs(dir) {
		if (hdapi.is_electron) {
			return electron_api.call("mkdirs", Array.from(arguments));
		}
	},
	/**
	 * 创建进程
	 * @param {string[]} cmds
	 * @param {object} [opts]
	 * @param {boolean} [opts.spawnMode] 返回进程ID而不是进程运行结束后的输出
	 * @returns {Promise<HDProc>}
	 */
	procCreate(cmds, opts) {
		if (hdapi.is_electron) {
			if (opts && opts.spawnMode)
				return electron_api.call("procCreate", Array.from(arguments)).then((x) => new HDProc(x));
			return electron_api.call("procCreate", Array.from(arguments));
		}
	},
	/**
	 * 获取进程
	 * @param {number} pid
	 * @returns {Promise<HDProc>}
	 */
	procGet(pid) {
		if (hdapi.is_electron) {
			return electron_api.call("procGet", Array.from(arguments)).then((x) => new HDProc(x.data));
		}
	},
	/**
	 * 获取所有进程ID
	 * @param {number} pid
	 * @returns {Promise<HDProc[]>}
	 */
	procList() {
		if (hdapi.is_electron) {
			return electron_api
				.call("procList", Array.from(arguments))
				.then((list) => list.map((x) => new HDProc(x)));
		}
	},
	exec(cmds, opts) {
		if (hdapi.is_electron) {
			return electron_api.call("exec", Array.from(arguments));
		}
	},
	eval(code) {
		code = hdapi.fn.apply(null, arguments);
		if (hdapi.is_electron) {
			return electron_api.call("eval", [code]);
		}
	},
	minimize() {
		if (hdapi.is_electron) {
			return electron_api.minimize();
		}
	},
	maximize(e) {
		if (hdapi.is_electron) {
			return electron_api.maximize(e);
		}
	},
	setWindow(size, bul, bul2) {
		if (hdapi.is_electron) {
			return electron_api.setWindow(size, bul, bul2);
		}
	},
	showMainWeb() {
		if (hdapi.is_electron) {
			return electron_api.showMainWeb();
		}
	},
	//#region 二次封装
	/**
	 * 读取JSON文件
	 * @param {string} path 文件路径
	 * @returns {Promise<any>}
	 */
	readJson(path) {
		return hdapi.readFile(path).then((x) => JSON.parse(x));
	},
	/**
	 *保存文件
	 * @param {string} path 保存路径
	 * @param {any} fileData 可以JSON.stringify的数据
	 * @returns {Promise<void>}
	 */
	writeJson(path, fileData) {
		return hdapi.writeFile(path, JSON.stringify(fileData));
	},
	/**
	 * 另存为，返回
	 * @param {string} title
	 * @param {any} fileData
	 * @returns {Promise<string>}
	 */
	saveAs(title, fileData) {
		let ext = hdapi.extname(title);
		title = hdapi.basename(title).slice(0, -ext.length);
		return hdapi
			.pickSaveFile(title, ext.slice(1))
			.then((path) => hdapi.writeJson(path, fileData).then(() => path));
	},
	/**
	 * 设置哪些链接使用默认浏览器打开
	 * @param {(url:string)=>boolean} fn
	 */
	setExternalURLFilter(fn) {
		return this.eval("this.filterExternalURL = " + fn);
	},
	/**
	 * @param {string} path
	 * @returns {Promise<Image>}
	 */
	loadImage(path) {
		return hdapi.readFile(path, "base64").then((url) => {
			url = "data:image/png;base64," + url;
			console.log("base64url");
			window.url = url;
			return new Promise(function (resolve, reject) {
				var img = document.createElement("img");
				img.src = url;
				img.onload = function () {
					resolve(img);
				};
				img.onerror = function (e) {
					reject(e);
				};
			});
		});
	},
	getVideoInfo(path) {
		return hdapi
			.procCreate([
				`ffprobe`,
				`-select_streams`,
				`v`,
				`-show_entries`,
				`format=width,height,duration,size,bit_rate`,
				`-show_streams`,
				`-v`,
				`quiet`,
				`-of`,
				`csv="p=0"`,
				`-of`,
				`json`,
				`-i`,
				path,
			])
			.then(function (ret) {
				console.log("JSON.parse(ret)=", JSON.parse(ret.stdout));
				return JSON.parse(ret.stdout);
			});
	},
	//#endregion
	//#region 通用函数
	fn(code) {
		if (typeof code === "function") {
			var args = Array.from(arguments);
			args.shift();
			return "(" + code + ")(" + JSON.stringify(args).slice(1, -1) + ");";
		}
		return code;
	},
	/**
	 * C:\xunjie\maincss.js 中的 .js
	 * @param {string} filepath
	 */
	extname(filepath) {
		let ss = filepath.split(".");
		if (!ss[0]) ss.shift();
		return ss.length > 1 ? "." + ss.pop() : "";
	},
	/**
	 * C:\xunjie\maincss.js 中的 maincss.js
	 * @param {string} filepath
	 */
	basename(filepath) {
		let ss = filepath.split(/\\|\//);
		let s = ss.pop();
		while (ss.length && !s) s = ss.pop();
		return s;
	},
	dirname(filepath) {
		let ss = filepath.split(/\\|\//);
		let s = ss.pop();
		while (ss.length && !s) s = ss.pop();
		return ss.join("/");
	},
	/**
	 * C:\xunjie\maincss.js 中的 maincss
	 * @param {string} filepath
	 */
	filename(filepath) {
		let filename = hdapi.basename(filepath);
		return filename.slice(0, -hdapi.extname(filename).length);
	},
	join() {
		return Array.from(arguments).join(getOS() == "WIN" ? "\\" : "/");
	},
	split(str) {
		return str.split(getOS() == "WIN" ? "\\" : "/");
	},
	arrayjoin(arr) {
		return arr.join(getOS() == "WIN" ? "\\" : "/");
	},
	/**
	 * @template T
	 * @param {T} dst
	 * @param {any} src
	 * @returns {T}
	 */
	deepAssign(dst, src) {
		if (src == undefined || typeof dst === "function") return dst;
		if (typeof dst === "object" && !Array.isArray(dst)) {
			for (let k in src) {
				if (k[0] != "_") dst[k] = this.deepAssign(dst[k], src[k]);
			}
			return dst;
		}
		return src;
	},
	/**
	 *
	 * @param {string} filepath
	 * @param {string} ext 后缀，不含".",可以用","分隔
	 */
	hasExt(filepath, ext) {
		let e = hdapi.extname(filepath).toLowerCase();
		return e.length > 1 && ~ext.split(",").indexOf(e.slice(1));
	},
	//#endregion
};
function getOS() {
	if (!window.electron_api) return "WEB";
	var ua = navigator.userAgent;
	if (~ua.indexOf("Windows NT")) return "WIN";
	if (~ua.indexOf("Mac")) return "MAC";
	if (~ua.indexOf("iPhone")) return "IPHONE";
	if (~ua.indexOf("iPad")) return "IPAD";
	if (~ua.indexOf("Android")) return "ANDROID";
	if (~ua.indexOf("Linux")) return "LINUX";
	return "OTHER";
}
function getOSversion() {
	var sUserAgent = navigator.userAgent;
	var isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
	var isMac =
		navigator.platform == "Mac68K" ||
		navigator.platform == "MacPPC" ||
		navigator.platform == "Macintosh" ||
		navigator.platform == "MacIntel";
	if (isMac) return "Mac";
	var isUnix = navigator.platform == "X11" && !isWin && !isMac;
	if (isUnix) return "Unix";
	var isLinux = String(navigator.platform).indexOf("Linux") > -1;
	if (isLinux) return "Linux";
	if (isWin) {
		var isWin2K =
			sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
		if (isWin2K) return "2000";
		var isWinXP =
			sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
		if (isWinXP) return "XP";
		var isWin2003 =
			sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
		if (isWin2003) return "2003";
		var isWinVista =
			sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
		if (isWinVista) return "Vista";
		var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
		if (isWin7) return "7";
		var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
		if (isWin10) return "10";
	}
	return "other";
}
class HDProc {
	/**
	 * @param {object} opts
	 * @param {number} opts.pid
	 * @param {string} [opts.stdout]
	 * @param {string} [opts.stderr]
	 */
	constructor(opts) {
		this.pid = opts.pid;
		this.stdout = opts.stdout;
		this.stderr = opts.stderr;
	}
	/**
	 * 等待进程执行完毕
	 * @returns {Promise<number>} 退出码
	 */
	wait() {
		return electron_api.call("procWait", [this.pid]);
	}
	/**
	 * 写入到stdin
	 * @param {string} base64
	 * @returns {Promise<boolean>}
	 */
	write(base64) {
		return electron_api.call("procWrite", [this.pid, base64]);
	}
	/**
	 * 杀进程
	 * @param {number} [code]
	 * @returns {Promise<boolean>}
	 */
	kill(code) {
		return electron_api.call("procKill", [this.pid, code]);
	}
	/**
	 * 获取进程信息,程序结束后返回null
	 * @returns {Promise<any>}
	 */
	get() {
		return electron_api.call("procGet", [this.pid]);
	}
}
window.hdapi = hdapi;
hdapi.ready = hdapi.getArgs().then((args) => {
	let filename = args[1];
	if (filename) hdapi.current_file_path = filename;
	console.log(args);
	function emitUpdate() {
		var event = document.createEvent("Event");
		event.initEvent("sw.update", true, true);
		window.dispatchEvent(event);
	}
	if (
		hdapi.is_electron &&
		location.origin.indexOf("localhost") < 0 &&
		"serviceWorker" in navigator
	) {
		navigator.serviceWorker
			.register("./sw.js")
			.then(function (reg) {
				if (reg.waiting) {
					emitUpdate();
					return;
				}

				reg.onupdatefound = function () {
					var installingWorker = reg.installing;
					installingWorker.onstatechange = function () {
						switch (installingWorker.state) {
							case "installed":
								if (navigator.serviceWorker.controller) {
									emitUpdate();
								}
								break;
						}
					};
				};
			})
			.catch(function (e) {
				console.error("Error during service worker registration:", e);
			});
	}
});
export default hdapi;
